import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.7 4.7h10.7m-.1 0-2.7 2.7m2.7-2.7L10.7 2m2.6 9.3H2.7m0 0L5.3 14m-2.6-2.7 2.7-2.7" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }